module.exports = __webpack_public_path__ + "static/media/restaurant-11.395c4f9e.jpg";